<template v-if="Object.keys(project).length !== 0">
    <div>
        <div class="between-center mb">
            <h4 class="title subheading is-3">
                <span>Services</span>
                <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                    <o-icon pack="fa" icon="gear" size="is-small"/>
                </a>
            </h4>
        </div>

        <div class="columns toolbar-box">
            <div class="column is-4-tablet is-2-desktop">
                <o-field class="is-marginless">
                    <o-select placeholder="Status" v-model="filters.serviceStatus" :expanded="true">
                        <option :value="null">View All</option>
                        <option
                            v-for="type in serviceStatuses"
                            :value="type.id"
                            :key="type.id">
                            {{ type.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-4-tablet is-3-desktop">
                <o-field>
                    <o-input
                            type="search"
                            v-model="filters.search"
                            placeholder="Search"
                            icon="search"
                    ></o-input>
                </o-field>
            </div>
            <div class="column is-4-tablet is-3-desktop">
                <o-field>
                    <multicomplete v-model="filterProjectServices" type="custom" :optionsProp="projectServices" fieldName="title" placeholder="services" />
                </o-field>
            </div>
            <div class="column is-4-tablet is-4-desktop action-box">
                <div class="field is-grouped justify-end">
                    <p class="control">
                        <router-link :to="{ name: 'change-orders.create', query: {project_id: currentProjectId}}" class="button is-dark">Create Change Order</router-link>
                    </p>
                    <p class="control">
                        <a @click.prevent="isCustomServiceModalActive = true" class="button is-dark">Add Expense</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns toolbar-box">
            <div class="column is-12-tablet is-12-desktop action-box">
                <div class="field is-grouped justify-end">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-default">Reset filters</a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger">Delete selected</a>
                    </p>
                    <p v-if="checkedRows.length > 0" class="control">
                        <a @click.prevent="handleDropSelected" class="button is-danger">Drop</a>
                    </p>
                    <p v-if="checkedRows.length > 0 && filters.serviceStatus != 'billed'" class="control">
                        <a @click.prevent="handleApproveSelected" class="button is-warning">Mark as Approved</a>
                    </p>
                    <p v-if="checkedRows.length > 0 && filters.serviceStatus != 'billed'" class="control">
                        <a @click.prevent="handleBillSelected" class="button is-warning">Send to Billing</a>
                    </p>
                    <p v-if="checkedRows.length > 0" class="control">
                        <a @click.prevent="handlePaySelected" class="button is-warning">Mark as Paid</a>
                    </p>
                    <p v-if="checkedRows.length > 0" class="control">
                        <a @click.prevent="openEstimatedBillDateModal(checkedRows)" class="button is-warning">Set Estimated Bill Date</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <o-table
                    class="project-services-table project-width-table is-responsive is-responsive-xs-desktop"

                    v-if="isTableVisible"
                    :data="filteredItems"
                    :opened-detailed="openedDetailed" 
                    detail-key="id"
                    :bordered="table.bordered"
                    :striped="table.striped"
                    :narrowed="table.narrowed"
                    :checkable="table.checkable"
                    :mobile-cards="table.mobileCards"
                    :paginated="table.paginated"
                    :pagination-simple="table.paginationSimple"
                    :per-page="table.perPage"
                    :default-sort-direction="table.defaultSortDirection"
                    :default-sort="table.defaultSort"
                    v-model:selected="selected"
                    :checked-rows="checkedRows"
                    @update:checkedRows="$event => checkedRows = $event"
                    :row-class="getRowClass"
                    :is-row-checkable="(row) => row.status != 'dropped' && (!hasInvalidEstimatedDates || !isEstimatedBillDateInvalid(row))"
                    detailed
                    detailed-key="id"
                >
                    <template>
                        <template>
                            <o-table-column
                                    v-for="col in tableColumns"
                                    v-bind="col"
                                    :field="col.field"
                                    :label="col.field === 'actions' ? '' : col.label"
                                    :sortable="col.sortable"
                                    :class="{notes: col.field === 'notes_history'}"
                                    #default="{ row }"
                            >
                                <router-link v-if="col.field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                                    {{ userNameById(row.last_editor_id) }}
                                </router-link>

                                <span v-if="col.field === 'type'">{{ row.source }}</span>

                                <dropdown-quick-edit
                                    v-if="col.field === 'status'"
                                    :entity="row"
                                    field="status"
                                    :update="updateProjectServiceStatus"
                                    :options="projectServiceStatuses"
                                    :disabled="isStatusDisabled(row)"
                                    v-select-no-keyboard
                                />

                                <dropdown-quick-edit
                                    v-if="col.field === 'assigned_to'"
                                    :entity="row"
                                    field="assigned_to"
                                    :update="partialUpdateProjectService"
                                    :options="activeUsers"
                                    :disabled="row.status == 'dropped'"
                                />

                                <span v-if="col.field === 'title'">{{ row.title }}</span>

                                <span v-if="col.field === 'work_types'">{{ workTypeNamesByIds(row.work_types) }}</span>

                                <div v-if="col.field === 'description'" v-html="nl2br(row.description)"></div>

                                <span v-if="col.field === 'price'">
                                    {{ $filters.currency(row.final_price) }}
                                </span>

                                <a v-if="col.field === 'estimated_bill_date' && row.status != 'dropped'" href="#" @click.prevent="openEstimatedBillDateModal(row)" v-bind:class="{ required : isEstimatedBillDateInvalid(row) }">
                                    {{ $filters.valueOrDefault($filters.date(row.estimated_bill_date)) }}
                                </a>
                                <span v-if="(col.field === 'estimated_bill_date' && row.status == 'dropped')">
                                    {{ $filters.valueOrDefault($filters.date(row.estimated_bill_date)) }}
                                </span>

                                <span v-if="col.field === 'notes_history'" @click="openNotesHistoryModal(row)">
                                    <ul>
                                        <li v-for="note in notesHistory[row.id]" :key="note.id">
                                            {{ note.value }}
                                        </li>
                                    </ul>
                                </span>

                                <span v-if="col.field === 'billed_at'">{{  $filters.date(row.billed_at) }}</span>

                                <span v-if="col.field === 'created_at'">{{  $filters.date(row.created_at) }}</span>

                                <span v-if="col.field === 'billed_by'">{{ userNameById(row.billed_by) }}</span>

                                <dropdown-quick-edit :disabled="!isCurrentUserAdmin"
                                    v-if="col.field === 'reimbursable'"
                                    :entity="row"
                                    field="reimbursable"
                                    :update="partialUpdateProjectService"
                                    :options="[{id: false, name: 'No'}, {id: true, name: 'Yes'}]"
                                />

                                <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                                  <template #trigger>
                                    <button class="button">
                                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                    </button>
                                  </template>
                                    <o-dropdown-item has-link><a @click="openReminderModal(row.id, 'project-service')">Set Reminder</a></o-dropdown-item>
                                    <o-dropdown-item has-link v-if="shouldScheduleLocEmail(row)" ><a @click="scheduleLoc(row)">Schedule LOC Email</a></o-dropdown-item>
                                </o-dropdown>
                            </o-table-column>
                        </template>
                    </template>

                    <template v-slot:empty>
                      <div class="has-text-centered">
                        This table is empty!
                      </div>
                    </template>

                    <template #detail="{ row }">
                        <div class="columns">
                            <div class="column is-6">
                                <strong>Scope of Work:</strong><br>
                                <div class="service-notation" v-html="row.description"></div>
                            </div>
                            <div class="column is-6">
                                <strong>To-do:</strong><br>
                                <checklist reference-type="project-service" :reference-id="row.id"></checklist>
                            </div>
                        </div>
                        <hr>
                        <div class="application-edit" v-if="isEditingApplication && currentEditServiceId == row.id">
                            <o-select placeholder="Select an Application" @update:modelValue="selectApplication" v-model="selectedApplication" expanded>
                                <option value="" selected>Not Specified</option>
                                <option
                                        v-for="(application, i) in applicationsByProjectId(currentProjectId)"
                                        :value="application"
                                        :key="i"
                                >
                                    {{ applicationName(application) }}
                                </option>
                            </o-select>
                            <div class="field" style="margin: 0px 10px">
                                <a style="width: 170px; margin: 10px 0;" @click="isApplicationModalActive = true" class="button is-primary">Add Application</a>
                            </div>
                            <a href="#" @click.prevent="saveApplication()" ><span class="icon"><i class="icm-save"></i></span><span>Save</span></a>
                            <a href="#" @click.prevent="endEditApplication()" ><span class="icon"><i class="icm-cancel"></i></span><span>Cancel</span></a>
                        </div>
                        <div v-else>
                            <strong>Application: {{ getServiceApplicationName(row) }}</strong>
                            <a href="#" @click.prevent="editApplication(row)">Change</a>
                        </div>
                        <o-tabs class="is-boxed">
                            <o-tab-item label="Comments">
                                <notes-comments :reference-id="row.id" reference-type="project-service" @onreply="replyComment" @created="commentCreated" :focusNoteId="+filters.focusNoteId" />
                            </o-tab-item>
                            <o-tab-item label="Tasks">
                            <p class="control">
                                <button @click="newTask(row)" class="button is-info" exact v-if="isNewTaskAvailable(row)"><span class="icon"><i class="icm-new"></i></span><span>New Task</span></button>
                            </p>
                            <o-table
                                class="project-services-table project-width-table is-responsive is-responsive-xs-desktop"
                                :data="servicesTasks(row.id)"
                                detailed
                                detailed-key="id"
                                >
                                <template>
                                    <o-table-column #default="{ row }" field="title" label="Title">
                                        {{ row.title }}
                                    </o-table-column>
                                    <o-table-column #default="{ row }" field="description" label="Description">
                                        <div v-html="row.description"></div>
                                    </o-table-column>
                                    <o-table-column #default="{ row }" field="status" label="Status">
                                        <dropdown-quick-edit :entity="row" field="status" :update="partialUpdateTask" :options="taskStatuses"/>
                                    </o-table-column>
                                    <o-table-column #default="{ row }" field="title" label="Assigned To">
                                        {{ userNameById(row.assignee_id) }}
                                    </o-table-column>
                                    <o-table-column #default="{ row }" field="title" label="Creator">
                                        {{ userNameById(row.creator_id) }}
                                    </o-table-column>
                                    <o-table-column #default="{ row }" field="latest_note" label="Lastest note">
                                        <div v-html="latestNoteMessageByTaskId(row.id)"></div>
                                    </o-table-column>
                                    <o-table-column #default="{ row }">
                                        <o-dropdown hoverable position="bottom-left" class="table-actions">
                                          <template #trigger>
                                            <button class="button">
                                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                            </button>
                                          </template>
                                            <o-dropdown-item has-link><a @click="openReplyModal(row.id)">Reply</a></o-dropdown-item>
                                            <o-dropdown-item has-link><a @click="openPreviewModal(row)">Print</a></o-dropdown-item>
                                            <o-dropdown-item has-link><router-link :to="{ name: 'tasks.show', params: { slug: row.id }, query: {project_id: currentProjectId} }">View Task</router-link></o-dropdown-item>
                                            <o-dropdown-item has-link><a @click="openReminderModal(row.id, 'task')">Set Reminder</a></o-dropdown-item>
                                        </o-dropdown>
                                    </o-table-column>
                                </template>
                                <template #detail="{ row }">
                                    <notes :reference-id="row.id" reference-type="task" @created="noteCreated"/>
                                </template>
                            </o-table>
                            </o-tab-item>
                        </o-tabs >
                        </template>
                    </o-table>
            </div>
        </div>

        <div class="columns">
            <div class="column is-offset-9 is-3">
                <b-panel :collapsible="true">
                  <template #header>
                    <strong>Summary</strong>
                  </template>
                    <div class="content full-width">
                        <p class="between-center"><strong>Total Quantity:</strong>
                            <span>{{ totalQuantity }}</span>
                        </p>
                        <p class="between-center"><strong>Total Revenue:</strong>
                            <span>{{  $filters.currency(totalExpenses) }}</span>
                        </p>
                        <p class="between-center"><strong>Payments:</strong>
                            <span>{{  $filters.currency(totalPayments) }}</span>
                        </p>
                    </div>
                </b-panel>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCustomServiceModalActive" has-modal-card>
            <custom-service-modal />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="reminderItemId" :reference-type="reminderType" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isEstimatedBillDateModalActive" has-modal-card>
            <service-estimated-bill-date :notesHistory="currentNotesHistory" :serviceinfo="currentService" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isNotesHistoryModalActive" has-modal-card>
            <notes-history-modal :projectService="currentService"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isApplicationModalActive" has-modal-card>
            <application-modal @select="selectApplication" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive" class="preview-modal" has-modal-card>
            <preview-modal :file="currentPreviewFile"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReplyModalActive" has-modal-card>
            <reply-modal :reference-id="taskId" reference-type="task"/>
        </o-modal>

    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
import Checklist from '../../../components/Checklist'
import ApplicationModal from '../../../components/modals/applications/Layout'
import CreateTask from '../../../components/modals/CreateTask'
import CustomServiceModal from '../../../components/modals/CustomServiceModal'
import NotesHistoryModal from '../../../components/modals/NotesHistoryModal'
import PreviewModal from '../../../components/modals/Preview'
import ScheduleLocEmailModal from '../../../components/modals/ScheduleLocEmailModal'
import NotesComments from '../../../components/NotesComments'
import Notes from '../../../components/NotesLite'
import Datepicker from './../../../components/Datepicker'
import ServiceEstimatedBillDate from './../../../components/modals/ServiceEstimatedBillDate'
import Table from './../../../mixins/Table'

    export default {
        mixins: [Table],

        components: {
            CustomServiceModal,
            Datepicker,
            NotesHistoryModal,
            ServiceEstimatedBillDate,
            ApplicationModal,
            PreviewModal,
            Notes,
            NotesComments,
            Checklist,
            CreateTask
        },

        computed: {
            ...mapGetters([
                'projectServicesExceptOfOptionalByProjectId',
                'projectServicesQuantityByProjectId',
                'projectServicesTotalCostByProjectId',
                'projectServicesPaymentsByProjectId',
                'projectServiceStatuses',
                'currentProjectId',
                'userNameById',
                'workTypeById',
                'isCurrentUserAdmin',
                'workTypeNamesByIds',
                'users',
                'currentUserId',
                'projectById',
                'currentProject',
                'tasksByProjectId',
                'applicationNameByTypeAndId',
                'applicationByTypeAndId',
                'taskStatuses',
                'latestNoteMessageByTaskId',
                'applicationsByProjectId',
                'applicationName',
                'notesByReference'
            ]),

            currentNotesHistory() {
                return this.currentService ? this.notesHistory[this.currentService.id] : []
            },

            filteredProjectServices() {
                let status = this.filters.serviceStatus
                return status ? _.filter(this.projectServices, { status }) : this.projectServices
            },

            projectServices() {
                return this.projectServicesExceptOfOptionalByProjectId(this.currentProjectId);
            },

            invalidEstimatedDates() {
                return this.projectServices.filter(p => this.isEstimatedBillDateInvalid(p));
            },

            hasInvalidEstimatedDates() {
              setTimeout(() => {
                return this.project.assigned_to === this.currentUserId && this.invalidEstimatedDates.length > 0;
              }, 1500)
            },
            project() {
                return this.projectById(this.currentProjectId);
            },
            filteredItems() {
                let f = this.filters,
                    q = this.filters.search.toLowerCase()

                var result = this.filterProjectServices.length > 0 ? this.filterProjectServices
                    : _.filter(this.filteredProjectServices, service => {
                    return service.title.toLowerCase().includes(q) || service.description.toLowerCase().includes(q) })
                return result;
            },

            serviceStatuses() { return [...this.projectServiceStatuses] },

            totalQuantity() {
                return _.reduce(this.filteredItems, (res, service) => {
                    return res + (service.source === 'service' ? 1 : 0)
                }, 0);
            },

            totalExpenses() {
                return _.reduce(this.filteredItems, (res, service) => {
                    return res + (service.source === 'service' && service.status !== 'dropped' ? service.final_price : 0)
                }, 0);
            },

            totalPayments() {
                return _.reduce(this.filteredItems, (res, service) => {
                    return res + ((service.status === 'paid' && service.source === 'service') ? service.final_price : 0)
                }, 0);
            },

            activeUsers() {
                return _.filter(this.users, user => ! user.blocked)
                        .map(user => { return { id : user.id, name: user.first_name + ' ' + user.last_name } })
            },
            locService() {
                return _.filter(this.projectServices, ps => this.shouldScheduleLocEmail(ps))[0]
            },
            isLocPending() {
                return this.locService && moment(this.locService.loc_send_date).isSameOrBefore(moment())
            },
            filterProjectServices: {
                get: function() {
                    return _.filter(this.projectServices, p => this.filters.serviceIds.includes(p.id+''))
                },
                set: function(newValue) {
                    this.filters.serviceIds = _.map(newValue, p => p.id+'')
                }
            },
            openedDetailed() {
                return this.filteredItems.length == 1 ? [this.filteredItems[0].id] : []
            }
        },

        data() {
            return {
                currentService: null,
                filters: {
                    serviceStatus: 'approved',
                    search: '',
                    serviceIds: [],
                    focusNoteId: ''
                },
                isTableSettingsModalActive: false,
                isEstimatedBillDateModalActive: false,
                isReminderModalActive: false,
                isCustomServiceModalActive: false,
                isNotesHistoryModalActive: false,
                notesHistory: {},
                reminderItemId: null,
                reminderType: null,
                tableName: 'project-services',
                currentEditServiceId: null,
                isEditingApplication: false,
                isApplicationModalActive: false,
                selectedApplication: null,
                isReplyModalActive: false,
                isPreviewModalActive: false,
                currentPreviewFile: null,
                taskId: null
            }
        },

        methods: {
            ...mapActions([
                'approveProjectService',
                'dropProjectServices',
                'fetchNotesHistoryRecent10',
                'payProjectService',
                'billProjectService',
                'billProjectServices',
                'openMessageModal',
                'partialUpdateProjectService',
                'clearServiceApplication',
                'scheduleLocEmail',
                'partialUpdateTask',
                'updateTasksApplication',
                'openGlobalTimelog'
            ]),

            ...mapActions({
                removeItem: 'removeProjectService2',
            }),

            fetchData () {
                return Promise.resolve({
                        data: {
                            data: this.projectServices,
                            pagination: {
                                total: 0
                            }
                        }
                    })
            },

            getRowClass(row) {
                return `project-service-${row.status}`
            },

            handleApproveSelected() {
                _.each(this.checkedRows, row => {
                    if (row.status !== 'approved') {
                        this.approveProjectService(row)
                    }
                })
            },

            handleBillSelected($bulk = true) {
                // this.checkedRows = [];
                let billedService = _.find(this.checkedRows, (service) => service.status === 'billed')

                if (billedService) {
                    this.$swal.fire({
                        text: 'Some services are billed already',
                        icon: 'error'
                    })
                } else {
                    if ($bulk) {
                        const projectServiceIds = _.map(this.checkedRows, 'id')
                        this.billProjectServices(projectServiceIds)
                    } else {
                        _.each(this.checkedRows, row => {
                            this.billProjectService(row)
                        })
                    }

                    this.$swal.fire({
                        text: 'Services have been billed successfull',
                        icon: 'success'
                    })
                }

                this.checkedRows = [];
            },

            handleDropSelected() {
                const servicesToDrop = this.checkedRows.filter(row => row.status !== 'dropped')
                .map(ps => ps.id)
                if (!servicesToDrop.length) {
                    return
                }
                const data = {
                    project_id: this.project.id,
                    project_services: servicesToDrop
                }
                const dropServices = () => this.dropProjectServices(data).then(res => {
                    const changeOrder = res.data.data.change_order
                    if(changeOrder && changeOrder.id) {
                        const project = this.project
                        const to = { name: 'change-orders.edit', params: { slug: changeOrder.id, project, proposal: changeOrder, changeOrder } }
                        this.$router.push(to)
                    }
                    return res
                }, r => Promise.reject(r))
                return this.confirmMessage(
                    'Are you sure?',
                    'This action cannot be undone.',
                    'Yes'
                ).then(dropServices, r => Promise.reject(r))
            },

            handlePaySelected() {
                _.each(this.checkedRows, row => {
                    if (row.status !== 'paid') {
                        this.payProjectService(row)
                    }
                })
            },
            
            isColumnGrayed(row) {
                return ["billed", "paid"].includes(row.status)
            },

            isEstimatedBillDateInvalid(projectService) {
                return projectService.status === 'approved' && (!projectService.estimated_bill_date || ( new Date(`${projectService.estimated_bill_date} `) < new Date(new Date().toLocaleDateString()) ));
            },

            isStatusDisabled(projectService) {
                return projectService.status === 'dropped' || ( this.hasInvalidEstimatedDates && this.isEstimatedBillDateInvalid(projectService) )
            },

            openEstimatedBillDateModal(service) {
                this.currentService = service
                this.isEstimatedBillDateModalActive = true
            },

            openNotesHistoryModal(service) {
                this.currentService = service
                this.isNotesHistoryModalActive = true
            },

            openReminderModal(id, reminderType) {
                this.reminderItemId = id
                this.reminderType = reminderType
                this.isReminderModalActive = true
            },

            setNotesHistory() {
                this.notesHistory = {}
                const promises = []
                this.projectServices.forEach(i => {
                    const p = this.fetchNotesHistoryRecent10(i.id).then(data => {
                        this.notesHistory[i.id] = data
                        return data
                    })
                    promises.push(p)
                })
                Promise.all(promises).then(() => {
                    this.$forceUpdate()
                })
            },

            async updateProjectServiceStatus(item) {
                if(item.status != 'approved') {
                    this.scheduleLocEmail({ id: item.id, loc_send_date: null })
                }
                const update = () => this.partialUpdateProjectService(item).then(res => {
                    const data = res.data.data,
                    changeOrder = data['change-order']
                    if( item.status === 'dropped' && changeOrder) {
                        const project = this.project
                        const to = { name: 'change-orders.edit', params: { slug: changeOrder.id, project, proposal: changeOrder, changeOrder } }
                        this.$router.push(to)
                    }
                    return res
                }, r => Promise.reject(r))
                if(item.status === 'dropped'){
                    return this.confirmMessage(
                        'Are you sure?',
                        'This action cannot be undone.',
                        'Yes'
                    ).then(update, r => Promise.reject(r))
                }
                if (item.status === 'billed') {
                    this.openGlobalTimelog( { project_id: this.currentProjectId, activity_type: 'project-service', activity_id: item.id, isShort: true, closable: false } )
                }
                return update()
            },
            shouldScheduleLocEmail(projectService) {
                return projectService.title == 'Letter of Completion' && (projectService.status == 'approved' || projectService.status == 'not_billable')
            },
            scheduleLoc(projectService) {
                this.openModalComponent(ScheduleLocEmailModal, { entity: projectService, entity_type: 'project-service' })
            },
            servicesTasks(serviceId) {
                return _.filter(this.tasksByProjectId(this.currentProjectId), p => p.project_service_id == serviceId)
            },
            isNewTaskAvailable(service) {
                return service.type != 'optional' && (service.status == 'approved' || service.status == 'not billable')
            },
            getServiceApplicationName(service) {
                if(service.application_id) {
                    return this.applicationNameByTypeAndId(service.application_type, service.application_id)    
                } else {
                    let serviceTasks = this.servicesTasks(service.id)
                    return serviceTasks && serviceTasks.length > 0 && serviceTasks[0].application_id ? this.applicationNameByTypeAndId(serviceTasks[0].application_type, serviceTasks[0].application_id) : 'Not defined'
                }
            },
            getServiceApplication(service) {
                return service.application_type ? this.applicationByTypeAndId(service.application_type, service.application_id) : null
            },
            editApplication(service) {
                this.selectedApplication = this.getServiceApplication(service)
                this.currentEditServiceId = service.id
                this.isEditingApplication = true
            },
            saveApplication() {
                if(this.selectedApplication) {
                    let serviceApplicationPayload = { id: this.currentEditServiceId, application_type: this.selectedApplication.application_type, application_id: this.selectedApplication.id, field: 'application_id'}
                    this.partialUpdateProjectService(serviceApplicationPayload)
                } else {
                    this.clearServiceApplication({ id: this.currentEditServiceId })
                }

                /*let tasks = _.map(this.servicesTasks(this.currentEditServiceId), p => p.id)
                if(tasks.length > 0) {
                    let taskPayload = { tasks, application_type: this.selectedApplication.application_type, id: this.selectedApplication.id }
                    this.updateTasksApplication(taskPayload)
                }*/
                this.endEditApplication()
            },
            endEditApplication() {
                this.currentEditServiceId = null
                this.isEditingApplication = false
            },
            selectApplication(application) {
                this.selectedApplication = application
                let tasks = this.servicesTasks(this.currentEditServiceId)
                _.forEach(tasks, p => {
                    p.application_id = application.id
                    p.application_type = application.type || application.application_type
                })  
            },
            openPreviewModal(task) {
                const port = window.location.port ? `:${window.location.port}` : '';
                this.currentPreviewFile = {
                    name: task.title,
                    mime: 'application/pdf',
                    path: `${window.location.protocol}//${window.location.hostname}${port}/tasks/${task.id}/pdf`,
                    generatedOnTheFly: true
                }
                this.isPreviewModalActive = true
            },

            openReplyModal (taskId) {
                this.isReplyModalActive = true
                this.taskId = taskId
            },
            noteCreated(referenceType, referenceId) {
                this.openGlobalTimelog( { project_id: this.currentProjectId, activity_type: referenceType, activity_id: referenceId, isShort: true, closable: false } )
            },
            newTask(service) {
                this.openModalComponent(CreateTask, {project_id: this.currentProjectId, project_service_id: service.id, application_type: service.application_type, application_id: service.application_id })
            },
            replyComment(note) {
                document.querySelector('#app > div > div.application.sidebar-menu-opened > div.section.content-wrapper > div > div > div > div > div > div.columns.is-multiline > div.column.is-12.is-12-tablet.is-9-desktop.is-10-fullhd.project-tabs > div:nth-child(2) > div:nth-child(4) > div > div > div.table-wrapper > table > tbody > tr.detail > td > div > div.columns > div:nth-child(2) > div > div.new-check > div > input').focus()
            },
            commentCreated(referenceType, referenceId) {
                this.openGlobalTimelog( { project_id: this.currentProjectId, activity_type: referenceType, activity_id: referenceId, isShort: true, closable: false, autoFill: true } )
            }
        },

        mounted () {
            if(this.hasInvalidEstimatedDates) {
                this.confirmMessage('Missing dates', 'Please fill in the missing Estimated Billing Dates, or add Notes if date is overdue').then(p => {
                    this.openEstimatedBillDateModal(this.invalidEstimatedDates[0]);
                });
            }
            if(this.isLocPending) {
                this.customMessage
                        ('LOC Send Email',
                            `Letter of Completion E-mail has not been sent yet.`,
                            [ 
                                { text: 'Close' },
                                { text: 'Postpone' },
                                { text: 'Send Mail' }
                            ])
                            .then((e) => {
                                    switch(e.button) {
                                        case 0:
                                            break
                                        case 1:
                                            this.openModalComponent(ScheduleLocEmailModal, { entity: this.locService, entity_type: 'project-service', shouldEnterNotes: true })
                                            break
                                        case 2:
                                            this.openMessageModal({ entity: this.currentProject, entity_type: 'project', context: 'loc-email-message', locService: this.locService })
                                            break
                                    }
                                })
            }
            this.setNotesHistory()
        },

        watch: {
            "filters.serviceStatus" () {
                this.clearCheckedRows();
            },
        },
    }
</script>

<style lang="sass">
td.chevron-cell
  span
    i::before
      font-size: 20px !important
      color: #1DA9E5 !important


.project-services-table
  tr.detail
    background: #d5d8da!important
  td.notes ul > li
    white-space: nowrap
  .detail-container
    margin: 0px 20px
    background-color: #fcfcfd
    .service-notation
      margin: 20px
    .table-wrapper
      min-height: auto
    .application-edit
      display: inline-flex
      margin-bottom: 10px
    .b-table
      border: 1px solid #c0c0c0
      margin-top: 10px
.quill-media.media-content
  border: 1px solid #c0c0c0
  border-radius: 5px
  overflow: visible
  padding: 1px
  .ql-snow
    .ql-stroke
      stroke: #6f6f6f
    .ql-fill
      fill: #6f6f6f
    &.ql-toolbar
      border: none
      padding: 2px
      button
        padding: 3px 0px
        width: 25px
    &.ql-container
      border: none
      border-top: 1px solid #ccc
  .thread-level
    background-color: #f5f8fa
    padding: 10px 5px
    padding-bottom: 0px!important
  .subscribers-multiselect-wrapper
    max-width: calc(100% - 177px)
    width: auto!important
    .multiselect
      margin-top: 0px
      height: 30px
      .multiselect__placeholder
        margin-bottom: 0px
        padding-top: 0px
      .multiselect__select
        height: 32px
      .multiselect__tags
        min-height: 32px
        padding: 4px 40px 0 8px
      .multiselect__tag
        padding: 4px 20px 4px 6px
        margin-right: 3px
        margin-bottom: 0px
</style>